import React from "react";

export function KpiCard({ label, value, subtext, icon, accent = "indigo" }) {
  const displayValue = value ?? "--";

  return (
    <div className={`ou-kpi ou-kpi--${accent}`}>
      <div className="ou-kpi-head">
        <span className="ou-kpi-label">{label}</span>
        {icon ? <span className="ou-kpi-icon">{icon}</span> : null}
      </div>
      <div className="ou-kpi-value" title={String(displayValue)}>
        {displayValue}
      </div>
      <div className="ou-kpi-sub">{subtext || "\u00A0"}</div>
    </div>
  );
}
